module.exports = __webpack_public_path__ + "img/prepare-lesson-down-disabled.b28f5469.svg";